module.exports = new __parcel__URL__("exercise10.094540cb.png").toString();